module.exports = __webpack_public_path__ + "img/immuTest4.b88f3be4.png";